export function chatMemory() {

    document.addEventListener('typingAnimationComplete', function (event) {
        const messageElement = event.detail?.message;
        const xpAdded = event.detail?.messageData?.user_xp_added ?? 0;

        // Memory saved animation — one bubble per memory saved, staggered
        const memoriesSaved = event.detail?.response?.data?.memories_saved ?? [];
        if (Array.isArray(memoriesSaved) && memoriesSaved.length > 0 && messageElement) {
            const baseDelay = xpAdded > 0 ? 2200 : 800;
            memoriesSaved.forEach((_, i) => {
                setTimeout(() => {
                    showMemoryBubble(messageElement);
                }, baseDelay + i * 700);
            });
        }
    });

    /**
     * Creates and shows a memory-saved bubble animation
     * @param {HTMLElement} container
     */
    function showMemoryBubble(container) {
        const originalPosition = container.style.position;
        container.style.position = 'relative';

        const bubble = document.createElement('div');
        bubble.className = 'g-chat-xp-bubble g-chat-memory-bubble';

        bubble.innerHTML = `<span class="xp-icon">🧠</span><span class="xp-amount">Memory updated</span>`;
        bubble.style.setProperty('--xp-bubble-color', '#b794f4'); // soft violet

        container.appendChild(bubble);

        requestAnimationFrame(() => {
            bubble.classList.add('is-animating');
        });

        setTimeout(() => {
            bubble.remove();
            container.style.position = originalPosition;
        }, 2800);
    }
}
